import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { title: String, text: String, url: String }

  share() {
    const url = this.urlValue
    const text = this.textValue
    const title = this.titleValue
    const fullText = [text, url].filter(Boolean).join(" ")

    if (navigator.share) {
      navigator.share({ title, text, url }).catch(e => {
        if (e.name !== "AbortError") this.#copy(fullText)
      })
    } else {
      this.#copy(fullText)
    }
  }

  #copy(text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => this.#flash("Copied!"))
        .catch(() => this.#execCopy(text))
    } else {
      this.#execCopy(text)
    }
  }

  #execCopy(text) {
    const el = Object.assign(document.createElement("textarea"), {
      value: text, style: "position:fixed;opacity:0"
    })
    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
    this.#flash("Copied!")
  }

  #flash(message) {
    const original = this.element.textContent.trim()
    this.element.textContent = message
    setTimeout(() => { this.element.textContent = original }, 1500)
  }
}
